import { useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';

// ── TO RE-ENABLE SIGNUPS: change false → true ─────────────────────────────────
const SIGNUPS_OPEN = false;
import { useAuthStore } from '../../store/useAuthStore';
import { useTheme } from '../../hooks/useTheme';
import UserAvatar from '../ui/UserAvatar';
import ProfileDropdown from './ProfileDropdown';

export default function Header() {
  const user = useAuthStore((s) => s.user);
  const { theme, toggle } = useTheme();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const closeDropdown = useCallback(() => setDropdownOpen(false), []);

  return (
    <header className="header">
      {/* Left: logo + primary nav */}
      <div className="header-left">
        <NavLink to={user ? '/practice' : '/'} className="header-logo">
          Code<strong>Drill</strong>
        </NavLink>
        <nav className="header-nav">
          <NavLink
            to="/practice"
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            practice
          </NavLink>
          <NavLink
            to="/leaderboard"
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            leaderboard
          </NavLink>
        </nav>
      </div>

      {/* Right: theme toggle + auth */}
      <div className="header-right">
        <button className="theme-toggle" onClick={toggle} aria-label="Toggle theme">
          {theme === 'dark' ? '☀' : '☽'}
        </button>

        {user ? (
          <div className="profile-trigger-wrap">
            <button
              className="profile-trigger"
              onClick={() => setDropdownOpen((o) => !o)}
              aria-haspopup="menu"
              aria-expanded={dropdownOpen}
            >
              <UserAvatar avatarUrl={user.avatarUrl} username={user.username} size="sm" />
              <span className="profile-trigger-name">{user.username}</span>
            </button>
            {dropdownOpen && (
              <ProfileDropdown user={user} onClose={closeDropdown} />
            )}
          </div>
        ) : (
          <>
            <NavLink
              to="/login"
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              login
            </NavLink>
            {SIGNUPS_OPEN && (
              <NavLink to="/register" className="btn btn--primary header-signup-btn">
                sign up
              </NavLink>
            )}
          </>
        )}
      </div>
    </header>
  );
}
